import {
	createContext,
	useState,
	SetStateAction,
	Dispatch,
	ReactNode,
} from 'react';

export type UnsavedChangesContextType = {
	/**
	 * Object [key]:boolean[] where the key corresponds to the stepper name and the array is every step we want to validate
	 */
	unsavedChanges: {
		field: boolean[];
		preset: boolean[];
	};
	setUnsavedChanges: Dispatch<
		SetStateAction<{
			field: boolean[];
			preset: boolean[];
		}>
	>;
	validateUnsavedChanges: {
		open: boolean;
		callback: () => void;
		context?: 'field' | 'preset';
	};
	setValidateUnsavedChanges: Dispatch<
		SetStateAction<{
			open: boolean;
			callback?: () => void;
			context?: 'field' | 'preset';
		}>
	>;
	resetUnsavedChanges: () => void;
};

interface UnsavedChangesContextProviderProps {
	children: ReactNode;
}
const initialValues = {
	unsavedChanges: {
		field: [false, false, false],
		preset: [false, false, false, false, false],
	},
	setUnsavedChanges: () => ({}),
	validateUnsavedChanges: { open: false, callback: () => ({}) },
	setValidateUnsavedChanges: () => ({}),
	resetUnsavedChanges: () => ({}),
};
export const UnsavedChangesContext = createContext<UnsavedChangesContextType>({
	...initialValues,
});

export function UnsavedChangesContextProvider({
	children,
}: UnsavedChangesContextProviderProps) {
	const [unsavedChanges, setUnsavedChanges] = useState(
		initialValues.unsavedChanges
	);
	const [validateUnsavedChanges, setValidateUnsavedChanges] = useState({
		open: false,
		callback: () => ({}),
	});
	const resetUnsavedChanges = () => {
		setUnsavedChanges(initialValues.unsavedChanges);
	};
	return (
		<UnsavedChangesContext.Provider
			value={{
				unsavedChanges,
				setUnsavedChanges,
				validateUnsavedChanges,
				setValidateUnsavedChanges,
				resetUnsavedChanges,
			}}
		>
			{children}
		</UnsavedChangesContext.Provider>
	);
}
